import React from "react";
import MuiTextField from "@mui/material/TextField";
import { textFieldProps } from "./fieldProps";

/** Keep digits only, at most `maxLength` of them. */
export const otpDigits = (raw, maxLength) => String(raw ?? "").replace(/\D+/g, "").slice(0, maxLength || undefined);

/**
 * `otp` — numeric, `inputmode="numeric"`, `autocomplete="one-time-code"` (the platform offers the SMS
 * code), `maxLength` 4–8 from the payload. Anything but a digit never reaches the value.
 */
export default function OtpField(props) {
	const { field, onChange } = props;
	return (
		<MuiTextField
			{...textFieldProps(props)}
			onChange={(e) => onChange(otpDigits(e.target.value, field.maxLength))}
			inputProps={{
				inputMode: "numeric",
				autoComplete: "one-time-code",
				pattern: "[0-9]*",
				maxLength: field.maxLength,
			}}
		/>
	);
}
